import { render, staticRenderFns } from "./table-diretrizes-eleitas.vue?vue&type=template&id=d586ebf4&scoped=true&"
import script from "./table-diretrizes-eleitas.vue?vue&type=script&lang=js&"
export * from "./table-diretrizes-eleitas.vue?vue&type=script&lang=js&"
import style0 from "./table-diretrizes-eleitas.vue?vue&type=style&index=0&id=d586ebf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d586ebf4",
  null
  
)

export default component.exports